<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="#ac8a2e"
          inline
          title="Informes"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                 <v-row>
                  <v-col cols="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                          <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                            <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="dataForm.fecha"
                          color="gold"
                          landscape
                          scrollable
                          locale="es-419"
                          no-title
                          @input="menu = false"
                        >
                        </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                   <base-upload-files folder="/documentaciones/informes" tipo="pdf" :documento-id="dataForm.documento_id" @documento="newFile = $event" />
                  </v-col>
                  <v-col cols="6">
                    <validation-provider
                      v-slot="{ errors }"
                      name="jugador"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="dataForm.jugador_id"
                        :error-messages="errors"
                        :items="jugadores"
                        item-value='id'
                        item-text='fullName'
                        :label="'Jugador'"
                        color="gold"
                        clearable
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.fullName" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="descripcion"
                      rules="required|max:191"
                    >
                      <v-textarea
                        v-model="dataForm.descripcion"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Descripcion"
                      />
                    </validation-provider>
                  </v-col>
                 </v-row>
                  <v-col
                    cols="12"
                  >
                    <v-row
                      justify="space-between"
                    >
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo',
      menu: false,
      newFile: null,
      dataForm: {
        id: '',
        fecha: '',
        jugador_id: '',
        descripcion: '',
      },
      jugadores: [],
      staff: [],
    }),
    computed: {

    },
    watch: {
      newFile (val) {
        if (val !== null) {
          this.$emit('fileChange', val)
        }
        this.dataForm.documento_id = this.newFile
      },
    },

    created () {
      if (this.mode === 'edit') {
        this.getInforme()
      }
      if (this.mode === 'pendiente') {
        this.setJugador()
      }
      this.setTittle()
      this.getJugadores()
      this.getStaff()
    },

    methods: {
      setTittle: function () {
        if (this.mode === 'new' || this.mode === 'pendiente') {
          this.tittle = 'Nuevo informe'
        } else {
          this.tittle = 'Editar informe'
        }
      },

      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },

      getStaff: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get' }).then(response => { this.staff = response })
      },

      getInforme: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/informe_get/' + this.id }).then(response => { this.dataForm = response })
      },

      setJugador () {
        this.dataForm.jugador_id = this.id
      },

      validateForm (scope) {
        this.saveInforme()
      },

      saveInforme: async function () {
        const mode = (this.mode === 'new' || this.mode === 'pendiente') ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/informe_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de Informe exitosa'] })
          this.$router.push({ name: 'Listado informes' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = (this.mode === 'new' || this.mode === 'pendiente') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/informe_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Informe creado'] })
          this.$router.push({ name: 'Listado informes' })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        }) */
      },
    },
  }
</script>
